// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  standingKey: __t.string().primaryKey().name("standing_key"),
  season: __t.u32(),
  racerKey: __t.string().name("racer_key"),
  identity: __t.identity(),
  npc: __t.bool(),
  name: __t.string(),
  points: __t.u32(),
  wins: __t.u16(),
  podiums: __t.u16(),
  starts: __t.u16(),
  bestMs: __t.u32().name("best_ms"),
  updatedAt: __t.timestamp().name("updated_at"),
});
